export default __webpack_public_path__ + "static/media/ogc-hero-stock-patio2-dark.ba86aa9b.jpg";